import React from 'react';
import {MasterLayout} from 'components/layouts';
import {FeedbackForm} from 'components/feedback-form';
import title from 'constants/TitlePages.js';

class FeedbackPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.FeedbackPage;
  }

  render() {
    return (
      <MasterLayout>
        <FeedbackForm/>
      </MasterLayout>
    );
  }
}

export default FeedbackPage;



// WEBPACK FOOTER //
// ./pages/feedback/FeedbackPage.jsx